export default __webpack_public_path__ + "static/Clinton-Presidential-Center-and-Park_LittleRock_Arkansas_008_2000px-cf37cef4e9ff97808b73ed672d3ddcd3.jpg";